import { FC } from "react"

interface RecipientChipsProps {
   items: string[]
}

const RecipientChips: FC<RecipientChipsProps> = ({ items }) => {
   return (
      <div className="alert-message-setting__recipients">
         {items.map((item) => {
            return (
               <span
                  className="alert-message-setting__recipient"
                  key={item}
               >
                  {item}
               </span>
            )
         })}
      </div>
   )
}

export default RecipientChips
